// PedidosVinculadosTab.jsx
import React, { useState, useEffect } from 'react'; // <-- 1. Importar useEffect

// Este componente recebe os dados de 'pedidos_vinculados'
// e a função 'onVerGrade' do ProducaoForm
function PedidosVinculadosTab({ pedidosData, onVerGrade }) {

    // 2. O estado inicializa como null
    const [pedidoAbertoId, setPedidoAbertoId] = useState(null);

    // 3. Este efeito define o primeiro pedido como aberto POR PADRÃO,
    //    mas apenas quando os dados são carregados pela primeira vez.
    //    Não vai mais interferir com seus cliques depois disso.
    useEffect(() => {
        if (pedidosData && pedidosData.length > 0) {
            setPedidoAbertoId(pedidosData[0].id);
        }
    }, [pedidosData]); // Depende apenas dos dados que chegam


    const togglePedido = (pedidoId) => {
        setPedidoAbertoId(prevId => (prevId === pedidoId ? null : pedidoId));
    };
    
    if (!pedidosData || pedidosData.length === 0) {
        return (
             <div className="form-section-card">
                 <h5 className="form-section-title">Pedidos Vinculados</h5>
                 <div className="alert alert-info text-center mb-0">
                     Nenhum item de pedido foi vinculado a esta Ordem de Produção.
                 </div>
             </div>
        );
    }

    return (
        <div className="form-section-card">
            <h5 className="form-section-title">Pedidos Vinculados</h5>
            <div className="accordion" id="accordionPedidosVinculados">
                {pedidosData.map((pedido) => { // <-- Removido 'index'
                    
                    // 4. A lógica 'isOpen' agora é muito mais simples.
                    //    Está aberto apenas se o ID corresponder.
                    const isOpen = pedidoAbertoId === pedido.id;

                    return (
                        <div className="accordion-item" key={pedido.id}>
                            <h2 className="accordion-header" id={`heading-pedido-${pedido.id}`}>
                                <button 
                                    className={`accordion-button ${isOpen ? '' : 'collapsed'}`} 
                                    type="button" 
                                    onClick={() => togglePedido(pedido.id)}
                                >
                                    Pedido #{pedido.numero} - Cliente: {pedido.cliente_nome}
                                </button>
                            </h2>
                            <div 
                                id={`collapse-pedido-${pedido.id}`} 
                                className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`} 
                            >
                                <div className="accordion-body p-2">
                                    <div className="table-responsive">
                                        <table className="table table-sm table-striped mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Produto</th>
                                                    <th>Cor</th>
                                                    <th>Grade</th>
                                                    <th className="text-end">Qtde. Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pedido.itens.map(item => (
                                                    <tr key={item.id}>
                                                        <td>{item.produto_codigo} - {item.produto_descricao}</td>
                                                        <td>{item.cor || '—'}</td>
                                                        <td>
                                                            {item.grade_descricao || '—'}
                                                            {item.tamanhos_json && (
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-outline-info btn-sm ms-2"
                                                                    // Passa o item no formato que o TamanhoModal espera
                                                                    onClick={() => onVerGrade({
                                                                        tamanhos_json: item.tamanhos_json,
                                                                        grade_descricao: item.grade_descricao
                                                                    })}
                                                                    title="Visualizar Configuração da Grade do Pedido"
                                                                >
                                                                    <i className="fa-solid fa-box-open"></i>
                                                                </button>
                                                            )}
                                                        </td>
                                                        <td className="text-end fw-bold">{item.quantidade_total}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default PedidosVinculadosTab;